(() => {
  'use strict';
  const root = document.querySelector('[data-home-film]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const video = root.querySelector('video');
  const replay = root.querySelector('[data-film-open]') || document.querySelector('[data-hero-film-open]');
  const play = root.querySelector('[data-film-play]');
  const sound = root.querySelector('[data-film-sound]');
  const status = root.querySelector('[data-film-status]');
  if (typeof dialog.showModal !== 'function' || !root.dataset.filmMp4) return;
  if (replay) replay.hidden = false;
  const preview = !window.Shopify || Shopify.theme?.role !== 'main' || Shopify.designMode;
  const key = `p5:launch-intro:2027-v1:${preview ? 'preview' : 'public'}`;
  let timer;
  let previousFocus;
  let previousOverflow;
  let cleaned = true;
  const message = text => { status.textContent = text; };
  const updateControls = () => {
    play.textContent = video.paused ? 'PLAY' : 'PAUSE';
    play.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
    sound.textContent = video.muted ? 'SOUND ON' : 'SOUND OFF';
    sound.setAttribute('aria-pressed', String(!video.muted));
  };
  const start = () => {
    const result = video.play();
    if (result?.catch) result.catch(() => {
      if (!dialog.open) return;
      clearTimeout(timer);
      message('Tap Play to start, or Enter site to continue.');
      updateControls();
    });
  };
  const restoreFocus = () => {
    if (dialog.open) return;
    if (previousFocus?.isConnected && previousFocus !== document.body) previousFocus.focus({preventScroll:true});
    else (replay || document.querySelector('#template-index a[href]'))?.focus({preventScroll:true});
  };
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    clearTimeout(timer);
    video.pause();
    video.removeAttribute('src');
    video.removeAttribute('poster');
    video.load();
    document.documentElement.style.overflow = previousOverflow;
    restoreFocus();
  };
  const close = () => { dialog.close(); cleanup(); };
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    try { dialog.showModal(); } catch (_) { return; }
    cleaned = false;
    document.documentElement.style.overflow = 'hidden';
    video.muted = true;
    video.poster = root.dataset.filmPoster;
    const hls = root.dataset.filmHls;
    video.src = hls && video.canPlayType('application/vnd.apple.mpegurl')
      ? hls : (matchMedia('(max-width: 600px)').matches && root.dataset.filmMobile || root.dataset.filmMp4);
    updateControls();
    message('');
    timer = setTimeout(() => {
      if (dialog.open && video.readyState < 3) message('The video is loading slowly. You can enter the site now or try Play.');
    }, 10000);
    start();
  };
  replay?.addEventListener('click', open);
  root.querySelector('[data-film-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    if (dialog.open) return;
    cleanup();
    // WebKit can restore native dialog focus after close() returns.
    requestAnimationFrame(restoreFocus);
  });
  video.addEventListener('ended', close);
  video.addEventListener('play', updateControls);
  video.addEventListener('pause', updateControls);
  video.addEventListener('volumechange', updateControls);
  video.addEventListener('playing', () => { clearTimeout(timer); message(''); });
  video.addEventListener('error', () => {
    if (dialog.open) { clearTimeout(timer); message('The video could not load. Try Play, or Enter site to continue.'); }
  });
  play.addEventListener('click', () => {
    if (video.paused) { if (video.error) video.load(); start(); } else video.pause();
  });
  sound.addEventListener('click', () => { video.muted = !video.muted; updateControls(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden && dialog.open) video.pause(); });
  window.addEventListener('pagehide', () => { if (dialog.open) close(); });
  if (window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
  // No source/poster is attached until after persistence and preferences are checked.
  // Fail open when persistence is unavailable; manual playback remains available.
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, 'seen');
  } catch (_) { return; }
  open();
})();
